import { useEffect, useState, useRef } from "react";
import WPLoginForm from "./WPLoginForm";
import WPRegistrationForm from "./WPRegistrationForm";
import WPResetPasswordForm from "./WPResetPasswordForm";


const NonLoggedUserForm = () => {

  const [isShowResetPasswordForm, setShowResetPasswordForm] = useState(false);
  const [isShowRegistrationForm, setShowRegistrationForm] = useState(false);
  const cacheRef = useRef(null);

  const handleShowResetPasswordForm = (val) => {
    setShowResetPasswordForm(val);

  }
  const showAccountForm = (val) => {
    setShowRegistrationForm(val)
  }

  const handleShowLoginForm = (val) => {
    setShowResetPasswordForm(val);
    setShowRegistrationForm(val);
  }

  const getCacheLoginForm = (val) => {
    cacheRef.current = val;
  }

  return (
    <>      
      { !isShowResetPasswordForm && !isShowRegistrationForm && <WPLoginForm onClickResetPassword={handleShowResetPasswordForm} onClickAccountForm={showAccountForm} handleCacheLoginForm={getCacheLoginForm} cacheValue={cacheRef.current} /> }
      {isShowResetPasswordForm && <WPResetPasswordForm onClickLoginForm={handleShowLoginForm} />}
      {isShowRegistrationForm && <WPRegistrationForm onClickLoginForm={handleShowLoginForm} />}
      
    </>
  );
};

export default NonLoggedUserForm;
